import React, { useState, useEffect } from 'react';

interface NameGeneratorFormProps {
  onSubmit: (firstName: string, surname: string) => Promise<void>;
  isLoading: boolean;
  initialValues?: {
    firstName: string;
    surname: string;
  };
}

export const NameGeneratorForm: React.FC<NameGeneratorFormProps> = ({
  onSubmit,
  isLoading,
  initialValues
}) => {
  const [firstName, setFirstName] = useState('');
  const [surname, setSurname] = useState('');

  // 设置初始值
  useEffect(() => {
    if (initialValues) {
      setFirstName(initialValues.firstName);
      setSurname(initialValues.surname);
    }
  }, [initialValues]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (firstName.trim() && surname.trim()) {
      await onSubmit(firstName.trim(), surname.trim());
    }
  };

  return (
    <div className="flex justify-center">
      <form onSubmit={handleSubmit} className="w-full max-w-md p-4 bg-white rounded-lg shadow-md space-y-4">
        <div className="space-y-3">
          <div>
            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
              First Name
            </label>
            <input
              type="text"
              id="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              placeholder="Enter your first name"
              required
            />
          </div>

          <div>
            <label htmlFor="surname" className="block text-sm font-medium text-gray-700 mb-1">
              Surname
            </label>
            <input
              type="text"
              id="surname"
              value={surname}
              onChange={(e) => setSurname(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              placeholder="Enter your surname"
              required
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={isLoading || !firstName.trim() || !surname.trim()}
          className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white 
            ${isLoading ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'}`}
        >
          {isLoading ? (
            <>
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Generating Your Chinese Name...
            </>
          ) : (
            'Generate Chinese Name'
          )}
        </button>
      </form>
    </div>
  );
};
